import { render, staticRenderFns } from "./CreateNewInterest.vue?vue&type=template&id=88d487ca&scoped=true&"
import script from "./CreateNewInterest.vue?vue&type=script&lang=js&"
export * from "./CreateNewInterest.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewInterest.vue?vue&type=style&index=0&id=88d487ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d487ca",
  null
  
)

export default component.exports